import { CometChat } from "@cometchat/chat-sdk-javascript";
import React from "react";
import { Action } from ".";

type Args = {
    searchText: string,
    groupsRequestBuilder: CometChat.GroupsRequestBuilder | null,
    searchRequestBuilder: CometChat.GroupsRequestBuilder | null,
    groupsSearchText:React.MutableRefObject<string>
};

export class GroupsManager {
    private groupsRequest: CometChat.GroupsRequest;
    private static loggedInUser: CometChat.User | null | undefined;
    private static defaultLimit = 30;

    /**
     * Set `groupsRequest` of the instance
     */
    constructor(args: Args) {
        const {
            searchText,
            groupsRequestBuilder,
            searchRequestBuilder,
            groupsSearchText
        } = args;
        let tmpGrpReqBuilder = groupsRequestBuilder || this.getDefaultRequestBuilder();
        if(searchText && searchRequestBuilder) {
            tmpGrpReqBuilder = searchRequestBuilder;
            tmpGrpReqBuilder.setSearchKeyword(searchText)
        }else if(searchText && !searchRequestBuilder && groupsRequestBuilder){
            tmpGrpReqBuilder = groupsRequestBuilder;
            tmpGrpReqBuilder.setSearchKeyword(searchText)
        }else if(!searchText && groupsRequestBuilder && searchRequestBuilder){
            tmpGrpReqBuilder = groupsRequestBuilder;
            tmpGrpReqBuilder.setSearchKeyword(groupsSearchText.current)
        }else if(!searchText && groupsRequestBuilder && !searchRequestBuilder){
            tmpGrpReqBuilder = groupsRequestBuilder;
            tmpGrpReqBuilder.setSearchKeyword(groupsSearchText.current)
        }else if(!searchText && !groupsRequestBuilder && searchRequestBuilder){
            tmpGrpReqBuilder = this.getDefaultRequestBuilder();
            tmpGrpReqBuilder.setSearchKeyword(groupsSearchText.current)
        }else{
            tmpGrpReqBuilder.setSearchKeyword(searchText)
        }
        this.groupsRequest = tmpGrpReqBuilder.build();
    }

    /**
     * Calls `fetchNext` method of the set `groupsRequest`
     */
    fetchNext() {
        return this.groupsRequest.fetchNext();
    }


    private getDefaultRequestBuilder() {
        return new CometChat.GroupsRequestBuilder().setLimit(GroupsManager.defaultLimit);
    }

    /**
     * Sets `loggedInUser` of the instance
     * @returns The logged-in user
     */
    private static async getLoggedInUser() {
        if (this.loggedInUser === undefined) {
            this.loggedInUser = await CometChat.getLoggedinUser();
        }
        return this.loggedInUser;
    }

    /**
     * Creates an SDK group listener
     */
    private static createGroupListener(dispatch: React.Dispatch<Action>) {
        return new CometChat.GroupListener({
            onGroupMemberJoined: async (message: CometChat.Action, joinedUser: CometChat.User, joinedGroup: CometChat.Group) => {
                if (joinedUser.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    joinedGroup.setHasJoined(true);
                }
                dispatch({ type: "updateGroup", group: joinedGroup });
            },
            onGroupMemberLeft: async (message: CometChat.Action, leavingUser: CometChat.User, groupLeft: CometChat.Group) => {
                if (leavingUser.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    groupLeft.setHasJoined(false);
                }
                dispatch({ type: "updateGroup", group: groupLeft });
            },
            onMemberAddedToGroup: async (message: CometChat.Action, userAdded: CometChat.User, userAddedBy: CometChat.User, userAddedIn: CometChat.Group) => {
                if (userAdded.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    userAddedIn.setHasJoined(true);
                }
                dispatch({ type: "updateGroup", group: userAddedIn });
            },
            onGroupMemberKicked: async (message: CometChat.Action, kickedUser: CometChat.User, kickedBy: CometChat.User, kickedFrom: CometChat.Group) => {
                if (kickedUser.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    kickedFrom.setHasJoined(false);
                }
                dispatch({ type: "updateGroup", group: kickedFrom });
            },
            onGroupMemberBanned: async (message: CometChat.Action, bannedUser: CometChat.User, bannedBy: CometChat.User, bannedFrom: CometChat.Group) => {
                if (bannedUser.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    dispatch({ type: "removeGroup", guid: bannedFrom.getGuid() });
                }
                else {
                    dispatch({ type: "updateGroup", group: bannedFrom });
                }
            },
            onGroupMemberUnbanned: async (message: CometChat.Action, unbannedUser: CometChat.User, unbannedBy: CometChat.User, unbannedFrom: CometChat.Group) => {
                if (unbannedUser.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    unbannedFrom.setHasJoined(false);
                    dispatch({ type: "prependGroup", group: unbannedFrom });
                }
            },
            onGroupMemberScopeChanged: async (message: CometChat.Action, changedUser: CometChat.User, newScope: CometChat.GroupMemberScope, oldScope: CometChat.GroupMemberScope, changedGroup: CometChat.Group) => {
                if (changedUser.getUid() === (await GroupsManager.getLoggedInUser())?.getUid()) {
                    changedGroup.setScope(newScope);
                }
                dispatch({ type: "updateGroup", group: changedGroup });
            }
        });
    }

    /**
     * Attaches an SDK group listener
     *
     * @returns Function to call to remove the attached SDK group listener
     */
    static attachListeners(dispatch: React.Dispatch<Action>) {
        const listenerId = "GroupsList_" + String(Date.now());
        CometChat.addGroupListener(listenerId, GroupsManager.createGroupListener(dispatch));
        return () => CometChat.removeGroupListener(listenerId);
    }
    /**
* Attaches an SDK websocket  listener
*
* @returns - Function to remove the added SDK websocket listener
*/
    static attachConnestionListener(callback: () => void) {
        const listenerId = "GroupsList_connection_" + String(Date.now());
        CometChat.addConnectionListener(
            listenerId,
            new CometChat.ConnectionListener({
                onConnected: () => {
                    console.log("ConnectionListener =>connected");
                    if (callback) {
                        callback()
                    }
                },
                onDisconnected: () => {
                    console.log("ConnectionListener => On Disconnected");
                }
            })
        );
        return () => CometChat.removeConnectionListener(listenerId);
    }
}
